import React, { useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
export const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  return <header className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-159">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-160">
        <div className="flex justify-between items-center h-16" data-id="element-161">
          <div className="flex items-center" data-id="element-162">
            <span className="text-2xl font-bold text-blue-600" data-id="element-163">DynoRoot</span>
          </div>
          {/* Desktop navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-164">
            <a href="#services" className="text-gray-600 hover:text-blue-600 transition-colors" data-id="element-165">
              Services
            </a>
            <a href="#features" className="text-gray-600 hover:text-blue-600 transition-colors" data-id="element-166">
              Features
            </a>
          
         
            <a href="#contact" className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors" data-id="element-167">
              Contact Us
            </a>
          </nav>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-168">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-blue-600 focus:outline-none" data-id="element-169">
              {isOpen ? <X size={24} data-id="element-170" /> : <Menu size={24} data-id="element-171" />}
            </button>
          </div>
        </div>
        {/* Mobile navigation */}
        {isOpen && <div className="md:hidden py-4" data-id="element-172">
            <div className="flex flex-col space-y-4 pb-4" data-id="element-173">
              <a href="#services" className="text-gray-600 hover:text-blue-600 transition-colors" onClick={() => setIsOpen(false)} data-id="element-174">
                Services
              </a>
              <a href="#features" className="text-gray-600 hover:text-blue-600 transition-colors" onClick={() => setIsOpen(false)} data-id="element-175">
                Features
              </a>
              <a href="#about" className="text-gray-600 hover:text-blue-600 transition-colors" onClick={() => setIsOpen(false)} data-id="element-176">
                About
              </a>
              <a href="#testimonials" className="text-gray-600 hover:text-blue-600 transition-colors" onClick={() => setIsOpen(false)} data-id="element-177">
                Testimonials
              </a>
              <a href="#contact" className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors text-center" onClick={() => setIsOpen(false)} data-id="element-178">
                Contact Us
              </a>
            </div>
          </div>}
      </div>
    </header>;
};